export default __webpack_public_path__ + "static/media/orangeTheme-girl.65ef86af.svg";